module.exports = __webpack_public_path__ + "img/chocolate.be5030ca.webp";